import firebase from 'firebase/app'
import 'firebase/auth'

// The configuration below is not sensitive data. You can serenely add your config here
const config = {
  apiKey: 'AIzaSyDIMHVeavTpLZ76XSCl5ohgKWKmhX5SqX8',
  authDomain: 'choche-wees.firebaseapp.com',
  projectId: 'choche-wees',
  storageBucket: 'choche-wees.appspot.com',
  messagingSenderId: '410957216233',
  appId: '1:410957216233:web:e66af6db553de2924a3378',
  measurementId: 'G-MHHS8GWJYC'
}

firebase.initializeApp(config)
